(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3973],{

/***/ 7572:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/frequently-asked-questions",
      function () {
        return __webpack_require__(89308);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ FaqWeb; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var components_faq_Faq__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53798);



var __N_SSG = true;
function FaqWeb(param) {
    var slug = param.slug, locale = param.locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_faq_Faq__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        slug: slug,
        locale: locale
    });
};


/***/ }),

/***/ 89308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _params___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91554);

var __N_SSG = true;
/**
 * This file is added, so the faq page will show general tab active on navigating to faq
 * The file can be removed if the faq url is changed with **"frequently-asked-questions/general"**
 * but to match PROD url structure, we've created this file
 */ /* harmony default export */ __webpack_exports__["default"] = (_params___WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6090,3798,9774,2888,179], function() { return __webpack_exec__(7572); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);